import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategorySection() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900">动漫分类</h2>
          <Link to="/category/all" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line align-middle"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {categories.filter(c => c.slug !== 'all').map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-center justify-center gap-2 px-4 py-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="font-heading text-sm text-foreground-700 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all text-sm"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}